const HEADERS = ['name', 'category', 'brand', 'price', 'duration', 'description', 'image', 'videoUrl'];

const escapeCsvCell = (value) => {
  const str = value === null || value === undefined ? '' : String(value);
  if (str.includes(',') || str.includes('"') || str.includes('\n')) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
};

const buildSampleRows = (categoryNames = [], brandNames = []) => {
  const cat1 = categoryNames[0] || 'Hair Services';
  const cat2 = categoryNames[1] || (categoryNames[0] ? categoryNames[0] : 'Skin Care');
  const brand1 = brandNames[0] || 'Sample Brand';

  return [
    [
      'Haircut',
      cat1,
      brand1,
      '500',
      '30',
      'Classic haircut with wash and blow dry',
      'https://example.com/images/haircut.jpg',
      'https://example.com/videos/haircut-intro.mp4'
    ],
    [
      'Hair Color',
      cat1,
      '',
      '2500',
      '90',
      'Full hair coloring including consultation',
      '',
      ''
    ],
    [
      'Facial Cleanup',
      cat2,
      brand1,
      '800',
      '45',
      'Deep cleansing facial for all skin types',
      'https://example.com/images/facial.jpg',
      ''
    ]
  ];
};

export const buildServiceBulkUploadSampleCsv = (categoryNames = [], brandNames = []) => {
  const rows = [HEADERS, ...buildSampleRows(categoryNames, brandNames)];
  return rows.map((row) => row.map(escapeCsvCell).join(',')).join('\n');
};

export const downloadServiceBulkUploadSample = (categoryNames = [], brandNames = []) => {
  const csv = `\uFEFF${buildServiceBulkUploadSampleCsv(categoryNames, brandNames)}`;
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = 'service-bulk-upload-sample.csv';
  link.click();
  URL.revokeObjectURL(link.href);
};
